import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Briefcase, Calendar } from "lucide-react";
import BlurText from "../BlurText";
import { HoverBorderGradient } from "../ui/hover-border-gradient";

const Hero = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0B0B0B]">
      {/* Background Overlay (grid texture) */}
      <div className="absolute inset-0 bg-[url('/grid.svg')] opacity-10 pointer-events-none" />

      {/* Blurred color blobs */}
      <div className="absolute -top-40 -left-40 w-[400px] h-[400px] rounded-full bg-[#202766] opacity-20 blur-3xl" />
      <div className="absolute top-20 -right-40 w-[350px] h-[350px] rounded-full bg-[#08B1CF] opacity-20 blur-3xl" />
      <div className="absolute bottom-0 left-1/3 w-[300px] h-[300px] rounded-full bg-[#342B8D] opacity-20 blur-3xl" />

      {/* Bottom fade gradient to blend with next component */}
      <div
        className="absolute bottom-0 left-0 right-0 h-32 z-[5] pointer-events-none"
        style={{
          background:
            "linear-gradient(to bottom, transparent 0%, rgba(11,11,11,0.8) 60%, rgba(0,0,0,1) 100%)",
        }}
      />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-6xl space-y-6">
        {/* Subtitle with BlurText */}
        <BlurText
          text="Empowering Students | Unlocking Opportunities"
          delay={100}
          animateBy="words"
          direction="top"
          className="text-xs sm:text-base md:text-lg text-white font-medium tracking-wide mb-4 text-center"
        />

        {/* Heading */}
        <motion.h1
          className="text-5xl sm:text-7xl md:text-8xl font-extrabold leading-tight tracking-tight 
          bg-gradient-to-r from-[#202766] via-[#08B1CF] to-[#342B8D] bg-clip-text text-transparent"
          initial={{ opacity: 0, y: -60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          OFF-CAMPUS
        </motion.h1>

        {/* Subheading */}
        <motion.p
          className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed font-light"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          College opportunities didn't work out? Don't worry—we help you land
          the dream opportunities your campus forgot to mention.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          className="flex flex-col md:flex-row gap-6 justify-center items-center pt-8 w-full max-w-md md:max-w-none mx-auto"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, delay: 0.7 }}
        >
          <a href="/programs" className="w-full">
            <HoverBorderGradient
              containerClassName="rounded-xl w-full h-full"
              as="button"
              className="flex items-center justify-center gap-3 px-8 py-4 text-lg font-semibold w-full h-full"
            >
              <span className="text-center">Internships/Jobs? Explore Now</span>
            </HoverBorderGradient>
          </a>

          <a href="/bookcall/101" className="w-full">
            <HoverBorderGradient
              containerClassName="rounded-xl w-full h-full"
              as="button"
              className="flex items-center justify-center gap-3 px-8 py-4 text-lg font-semibold w-full h-full"
            >
              <span className="text-center">Career Guidance? Book Now</span>
            </HoverBorderGradient>
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
